// ============================================================
// SERVICES — DEMO / PLACEHOLDER DATA
// These are editable sample services. Replace them with the
// hospital's actual service list once confirmed.
// ============================================================

export const SERVICES = [
  {
    slug: "general-medicine",
    name: "General Medicine",
    icon: "stethoscope",
    short: "Diagnosis and treatment of common adult health conditions.",
    description:
      "Our general medicine consultations cover everyday illnesses, ongoing conditions and overall health concerns. The doctor reviews your history, examines you and explains the next steps clearly. This is demo content — update it with the hospital's actual service details.",
    whoFor: ["Adults with new or ongoing health concerns", "Patients needing a first medical opinion", "Anyone seeking a routine health review"],
    isDemo: true,
  },
  {
    slug: "general-consultation",
    name: "General Consultation",
    icon: "clipboard",
    short: "Everyday doctor consultations for the whole community.",
    description:
      "Walk-in and appointment-based consultations for common health problems, follow-up visits and medical advice. This is demo content — update it with the hospital's actual consultation process and timings.",
    whoFor: ["Individuals and families in Kasdol", "Patients needing follow-up visits", "Anyone unsure which specialist to see"],
    isDemo: true,
  },
  {
    slug: "family-healthcare",
    name: "Family Healthcare",
    icon: "users",
    short: "Continuing care for every member of your family.",
    description:
      "Family healthcare focuses on long-term, relationship-based care for all ages — children, adults and elders — under one roof. This is demo content — update it with the hospital's actual family care services.",
    whoFor: ["Families seeking a regular doctor", "Elders needing ongoing support", "Parents managing family health needs"],
    isDemo: true,
  },
  {
    slug: "preventive-healthcare",
    name: "Preventive Healthcare",
    icon: "shield",
    short: "Check-ups and guidance that help you stay ahead of illness.",
    description:
      "Preventive care includes routine health check-ups, risk assessment and practical lifestyle guidance to catch concerns early. This is demo content — update it with the hospital's actual health check-up packages.",
    whoFor: ["Adults due for a routine check-up", "People with a family history of illness", "Anyone wanting structured health guidance"],
    isDemo: true,
  },
  {
    slug: "diagnostics",
    name: "Diagnostics",
    icon: "flask",
    short: "Basic diagnostic support to guide accurate treatment.",
    description:
      "Diagnostic support helps doctors confirm a diagnosis and monitor treatment. The exact tests available should be confirmed with the hospital. This is demo content — update it with the hospital's actual diagnostic facilities.",
    whoFor: ["Patients advised tests by a doctor", "People doing preventive screening", "Follow-up patients monitoring a condition"],
    isDemo: true,
  },
  {
    slug: "womens-health",
    name: "Women's Health",
    icon: "heart",
    short: "Respectful, private care for women at every life stage.",
    description:
      "Women's health consultations cover routine concerns, antenatal check-ups and preventive guidance in a comfortable setting. This is demo content — update it with the hospital's actual women's health services.",
    whoFor: ["Women seeking routine consultations", "Expecting mothers for check-ups", "Women advised preventive screening"],
    isDemo: true,
  },
  {
    slug: "child-healthcare",
    name: "Child Healthcare",
    icon: "baby",
    short: "Gentle, attentive care for infants and children.",
    description:
      "Child healthcare covers common childhood illnesses, growth monitoring and vaccination counselling, with guidance for parents at every visit. This is demo content — update it with the hospital's actual child care services.",
    whoFor: ["Newborns and infants", "School-age children", "Parents seeking growth or nutrition advice"],
    isDemo: true,
  },
  {
    slug: "minor-procedures",
    name: "Minor Procedures",
    icon: "bandage",
    short: "Small clinical procedures performed with care and hygiene.",
    description:
      "Minor procedures such as dressings and small clinical interventions are handled in a clean, well-prepared environment. This is demo content — update it with the procedures the hospital actually performs.",
    whoFor: ["Patients advised a minor procedure", "Wound care and dressing needs", "Patients referred by a doctor"],
    isDemo: true,
  },
];

export const getServiceBySlug = (slug) => SERVICES.find((s) => s.slug === slug);
